import { Helmet } from 'react-helmet';
import BaodoDetail
  from 'src/components/baodo-detail/BaodoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import BaodoListToolbar from '../components/baodo-detail/BaodoToolbar';

const Baodo = () => (
  <>
    <Helmet>
      <title>Báo đỏ</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <BaodoListToolbar />
        <Box sx={{ pt: 3 }}>
          <BaodoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Baodo;
